module.exports = __webpack_public_path__ + "media/images/weather/156_day-e7021916dbff7da7119fc6a81b9cd144.png";